import './style.scss';
import $ from "jquery";
import jQueryBridget from 'jquery-bridget';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import Flickity from 'flickity';
import 'flickity-imagesloaded';

jQueryBridget( 'flickity', Flickity, $ );
gsap.registerPlugin(ScrollTrigger);
$(document).ready(() => {
    $('.wp-block-thanxblocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity({
        pageDots: false,
        prevNextButtons: false,
        groupCells: false,
        contain: true,
        imagesLoaded: true,
        percentPosition: true,
        wrapAround: true,
        autoPlay: 4000,
    });

    $('.wp-block-thanxblocks-latest-posts__gallery-button--prev').on( 'click', function() {
        $('.wp-block-thanxblocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('previous');
    });

    $('.wp-block-thanxblocks-latest-posts__gallery-button--next').on( 'click', function() {
        $('.wp-block-thanxblocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('next');
    });
    function postReveal() {
        if($(".wp-block-thanxblocks-latest-posts__article").length) {
            $(".wp-block-thanxblocks-latest-posts__article").each(function() {
                var self = $(this);
                var tl = gsap.fromTo(self, {scale:0.8,y:80,autoAlpha:0},{scale:1,y:0,autoAlpha:1,duration:0.6});
                var st = ScrollTrigger.create({
                    trigger: self,
                    start: "top bottom",
                    // toggleActions: "play reverse play reverse",
                    // markers: {startColor: "blue", endColor: "yellow", indent: 100},
                    animation: tl
                });
                
            });
        }
    }
    postReveal();
    function buttonHover() {
        if($('.wp-block-thanxblocks-latest-posts__readmore').length) {
                $(".wp-block-thanxblocks-latest-posts__readmore").each(function() {
                    var self = $(this),
                        dataHoverColor = self.attr("data-color"),
                        dataHoverBorderColor = self.attr("data-borcolor"),
                        tl = gsap.timeline({paused:true});
                        if(self.hasClass("has-b")) {
                            tl.to(self, {duration:0.3, borderColor:dataHoverBorderColor, color:dataHoverColor, ease:"none"});
                        } else {
                            tl.to(self, {duration:0.3, color:dataHoverColor, ease:"none"});
                        }

                    self.on("mouseenter", () => {
                        tl.play();
                    }).on("mouseleave", () => {
                        tl.reverse();
                    })
                })
        }
    }
    buttonHover()
});